import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { RadioButton, Input, InputFile, DropDown } from '../components'
import { catSiNo, catIdentificationType } from '../data/MochaData'
import { ValidateEmail } from '../../../utils/helpMain'

const Step3 = () => {
    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);
    const [lblDriverLicenseImage, setLblDriverLicenseImage] = useState('')
    const [touched, setTouched] = useState(false);
    const [errorMail, setErrorMail] = useState({ errorMessage: '', isValid: true } as IEmailValidationResult);

    const changeRadio = (propierties: string, value: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    const changeCbo = (propierties: string, value: string) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: files, [`${propierties}IsModified`]: isMod });

    useEffect(() => {
        if (ReclamosInspeccionNI.isInsuredDriver === 'S')
            setLblDriverLicenseImage('Fotografía de la licencia de conducir del asegurado*')
        else if (ReclamosInspeccionNI.isInsuredDriver === 'N')
            setLblDriverLicenseImage('Fotografía de la licencia de conducir del conductor*')
        else
            setLblDriverLicenseImage('')
    }, [ReclamosInspeccionNI.isInsuredDriver])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [e.target.name]: e.target.value })     
        if (touched) setErrorMail(ValidateEmail(value));
    }

    const handleBlur = () => {   
        setTouched(true);
        setErrorMail(ValidateEmail(ReclamosInspeccionNI.insuredMail));
    };

    return (
        <>
            <RadioButton
                label='¿El asegurado es el conductor del vehículo?*'
                field={'isInsuredDriver'}
                key={'isInsuredDriver'}
                value={ReclamosInspeccionNI.isInsuredDriver}
                onChange={changeRadio}
                catalog={catSiNo}
            />

            {ReclamosInspeccionNI.isInsuredDriver === 'S' &&

                <Input
                    id='insuredName'
                    field='insuredName'
                    onChange={changeHandler}
                    label='Nombres del Asegurado'
                    value={ReclamosInspeccionNI.insuredName}
                />

            }

            {ReclamosInspeccionNI.isInsuredDriver === 'N' && <div>
                <DropDown
                    label='Tipo de identificación*'
                    field='driverIdentificationType'
                    valueSelect={ReclamosInspeccionNI.driverIdentificationType}
                    dataProvider={catIdentificationType}
                    onChangeSelect={changeCbo}

                />

                {ReclamosInspeccionNI.driverIdentificationType === '1' &&
                    <Input
                        id='driverIdentification'
                        field='driverIdentification'
                        onChange={changeHandler}
                        label='Número de identificación*'
                        value={ReclamosInspeccionNI.driverIdentification}
                        type='mask'
                        mask="999-999999-9999a"
                        pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                        title="Documento invalido"
                        placeholder='Ejemplo: 000-000000-0000A'
                    />
                }
                {ReclamosInspeccionNI.driverIdentificationType !== '1' &&
                    <Input
                        id='driverIdentification'
                        field='driverIdentification'
                        onChange={changeHandler}
                        label='Número de identificación*'
                        value={ReclamosInspeccionNI.driverIdentification}
                    />
                }

            </div>
            }
            {ReclamosInspeccionNI.isInsuredDriver !== '' && <div>
                <InputFile
                    id='identificationFrontImage'
                    label='Toma una fotografía de la parte delantera de la identificación*'
                    files={ReclamosInspeccionNI.identificationFrontImage}
                    onChange={changeFiles}
                    maxFiles={1}
                />

                <InputFile
                    id='identificationBackImage'
                    label='Toma una fotografía de la parte trasera de la identificación*'
                    files={ReclamosInspeccionNI.identificationBackImage}
                    onChange={changeFiles}
                    maxFiles={1}
                />
            </div>
            }

            {ReclamosInspeccionNI.isInsuredDriver === 'S' && <div>
                <Input
                    id='insuredCellPhone'
                    field='insuredCellPhone'
                    onChange={changeHandler}
                    label='Celular del Asegurado*'
                    value={ReclamosInspeccionNI.insuredCellPhone}
                    placeholder="8888-8888"
                    type='mask'
                    mask="9999-9999"
                />
                <Input
                    id='insuredMail'
                    field='insuredMail'
                    onChange={handleChange}
                    label='Correo electrónico del Asegurado*'
                    value={ReclamosInspeccionNI.insuredMail}
                    placeholder="Ejemplo: usuario@dominio.com"
                    ariainvalid={!errorMail.isValid}
                    error={!errorMail.isValid}
                    title={errorMail.errorMessage}
                    onBlur={handleBlur}

                />
                <Input
                    id='insuredAddress'
                    field='insuredAddress'
                    onChange={changeHandler}
                    label='Dirección de actual domicilio del Asegurado*'
                    value={ReclamosInspeccionNI.insuredAddress}
                    type='textarea'
                    placeholder='Ingresar dirección del Asegurado'
                />
            </div>
            }

            {ReclamosInspeccionNI.isInsuredDriver === 'N' && <div>
                <Input
                    id='driverFirstName1'
                    field='driverFirstName1'
                    onChange={changeHandler}
                    label='Nombres*'
                    value={ReclamosInspeccionNI.driverFirstName1}
                    placeholder="Primer Nombre"
                />
                <Input
                    id='driverFirstName2'
                    field='driverFirstName2'
                    onChange={changeHandler}
                    label=''
                    value={ReclamosInspeccionNI.driverFirstName2}
                    placeholder="Segundo Nombre"
                    onlyInput={true}
                    isRequired={false}
                />
                <Input
                    id='driverLastName1'
                    field='driverLastName1'
                    onChange={changeHandler}
                    label='Apellidos*'
                    value={ReclamosInspeccionNI.driverLastName1}
                    placeholder="Primer Apellido"
                />
                <Input
                    id='driverLastName2'
                    field='driverLastName2'
                    onChange={changeHandler}
                    label=''
                    value={ReclamosInspeccionNI.driverLastName2}
                    placeholder="Segundo Apellido"
                    onlyInput={true}
                    isRequired={false}
                />
                <Input
                    id='driverCellPhone'
                    field='driverCellPhone'
                    onChange={changeHandler}
                    label='Celular*'
                    value={ReclamosInspeccionNI.driverCellPhone}
                    placeholder="8888-8888"
                    type='mask'
                    mask="9999-9999"
                />
                <Input
                    id='driverMail'
                    field='driverMail'
                    onChange={changeHandler}
                    label='Correo electrónico*'
                    value={ReclamosInspeccionNI.driverMail}
                    placeholder="Ejemplo: usuario@dominio.com"
                />
                <Input
                    id='driverCompanions'
                    field='driverCompanions'
                    onChange={changeHandler}
                    label='¿Quiénes acompañaban al conductor del vehículo?'
                    value={ReclamosInspeccionNI.driverCompanions}
                    type='textarea'
                    isRequired={false}
                />

            </div>
            }

            {ReclamosInspeccionNI.isInsuredDriver !== '' &&
                <InputFile
                    id='driverLicenseImage'
                    label={lblDriverLicenseImage}
                    files={ReclamosInspeccionNI.driverLicenseImage}
                    onChange={changeFiles}
                    maxFiles={2}
                />
            }
        </>
    )
}

export { Step3 }